module.exports = __webpack_public_path__ + "img/map-sites2.7f86b840.png";